import { render, staticRenderFns } from "./buyerBillOrderWaitCreate.vue?vue&type=template&id=60feb76f&"
import script from "./buyerBillOrderWaitCreate.vue?vue&type=script&lang=js&"
export * from "./buyerBillOrderWaitCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports